import styled from 'styled-components';

export const NameCellContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const NameSkuContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const TotalCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

export const TooltipText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const QuantityContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
